import { render } from "./OwnGroupPage.vue?vue&type=template&id=76093e44&scoped=true"
import script from "./OwnGroupPage.vue?vue&type=script&lang=js"
export * from "./OwnGroupPage.vue?vue&type=script&lang=js"

import "./OwnGroupPage.vue?vue&type=style&index=0&id=76093e44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76093e44"]])

export default __exports__